import api from './api';

export const getTrainingDashboard = async () => (await api.get('/training/dashboard')).data;

export const getExamTemplates = async (activeOnly = false) => (
  await api.get('/training/templates', { params: { active_only: activeOnly } })
).data;

export const createExamTemplate = async (payload) => (
  await api.post('/training/templates', payload)
).data;

export const getClassrooms = async (centerId = null) => (
  await api.get('/training/classrooms', { params: { center_id: centerId } })
).data;

export const createClassroom = async (payload) => (
  await api.post('/training/classrooms', payload)
).data;

export const updateClassroom = async (classroomId, payload) => (
  await api.patch(`/training/classrooms/${classroomId}`, payload)
).data;

export const deleteClassroom = async (classroomId) => (
  await api.delete(`/training/classrooms/${classroomId}`)
).data;

export const purgeClassroomStudents = async (classroomId, force = false) => (
  await api.post(`/training/classrooms/${classroomId}/purge-students`, null, { params: { force } })
).data;

export const getClassroomGradebook = async (classroomId) => (
  await api.get(`/training/reports/classroom/${classroomId}`)
).data;

export const enrollStudents = async (classroomId, userIds) => (
  await api.post(`/training/classrooms/${classroomId}/enrollments`, { user_ids: userIds })
).data;

export const getAssignments = async (mine = false) => (
  await api.get('/training/assignments', { params: { mine } })
).data;

export const createAssignment = async (payload) => (
  await api.post('/training/assignments', payload)
).data;

export const startExamSession = async (payload) => (
  await api.post('/training/sessions', payload)
).data;

export const getActiveExamSession = async (datasetId = null) => (
  await api.get('/training/sessions/active', { params: datasetId ? { dataset_id: datasetId } : {} })
).data;

export const getAllActiveExamSessions = async () => (
  await api.get('/training/sessions/active', { params: { all: true } })
).data;

export const getExamSession = async (sessionId) => (
  await api.get(`/training/sessions/${sessionId}`)
).data;

export const saveExamSession = async (sessionId, payload) => (
  await api.put(`/training/sessions/${sessionId}`, payload)
).data;

export const abandonExamSession = async (sessionId) => (
  await api.delete(`/training/sessions/${sessionId}`)
).data;

export const submitExamSession = async (sessionId) => (
  await api.post(`/training/sessions/${sessionId}/submit`)
).data;

export const getAttempts = async (limit = 50, mine = false) => (
  await api.get('/training/attempts', { params: { limit, mine } })
).data;

export const getAttempt = async (attemptId) => (
  await api.get(`/training/attempts/${attemptId}`)
).data;

export const updateQuestionMetadata = async (questionId, payload) => (
  await api.patch(`/training/questions/${questionId}`, payload)
).data;

export const getQuestionAuditLogs = async (questionId) => (
  await api.get(`/training/questions/${questionId}/logs`)
).data;

export const recordPracticeSession = async (payload) => (
  await api.post('/training/practice-session', payload)
).data;
